import useTranslator from "../../hooks/useTranslator";
import styles from "./ApplicationPeopleSummary.module.css";

export type ApplicationMember = {
  name: string;
  email?: string;
  role: "tenant" | "guarantor";
};

type Props = {
  members?: ApplicationMember[];
};

export default function ApplicationPeopleSummary({ members = [] }: Props) {
  const { _t } = useTranslator();

  if (members.length === 0) return null;

  return (
    <div
      className={styles.people}
      aria-label={_t("applicationMembers", "Application members")}
    >
      {members.map((member, index) => (
        <div
          className={styles.person}
          key={`${member.role}-${member.email || member.name}-${index}`}
          title={member.email}
        >
          <span className={styles.avatar} aria-hidden="true">
            {member.name.trim().charAt(0).toUpperCase() || "?"}
          </span>
          <span className={styles.name}>{member.name}</span>
          <span className={styles.role}>
            {_t(member.role === "guarantor" ? "guarantor" : "tenant")}
          </span>
        </div>
      ))}
    </div>
  );
}
